






import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  name: 'Avatar',
  components: {}
})
export default class Avatar extends Vue {
  @Prop({ type: String, default: ''}) protected name!: string
  @Prop({ type: String, default: ''}) protected color!: string
  @Prop({ type: Number, default: null }) protected index!: any
  @Prop({ type: Boolean, default: false }) protected isAbsolute!: boolean

  get iconStyles() {
    if (this.isAbsolute) return {
      backgroundColor: '#' + this.color,
      right: this.calculateAvatarPosition(this.index)
    }
    else return {
      backgroundColor: '#' + this.color
    }
  }

  get avatarInitials() {
    if (!this.name) return ''
    return this.name
      .trim()
      .split(' ')
      .slice(0, 2)
      .map((word: string) => (word[0].toUpperCase()))
      .join('')
  }

  calculateAvatarPosition(avatarIdx: number) {
    return avatarIdx * 36 + 'px'
  }
}
